export function listRDPSLayers() {
    return layers.filter(l => l.type === "RDPS");
}

export function listRadarLayers() {
    return layers.filter(l => l.type === "radar");
}

export const layers = [
    {
      type: "radar",
      layer: "RADAR_1KM_RDBR",
      style: "RADARURPREFLECTR14-LINEAR",
      title: "Radar reflectivity (Rain) (1 km) [dBZ]",
      interval: -10,
      opacity: 1,
    },
    {
        type: "radar",
      layer: "RADAR_1KM_RRAI",
      style: "RADARURPPRECIPR14-LINEAR",
      title: "Radar precipitation rate (Rain) (1 km) [mm/hr]",
      interval: -10,
      opacity: 1,
    },
    {
        type: "radar",
      layer: "RADAR_1KM_RSNO",
      style: "RADARURPPRECIPS14-LINEAR",
      title: "Radar precipitation rate (Snow) (1 km) [cm/hr]",
      interval: -10,
      opacity: 1,
    },
    {
      type: "radar",
    layer: "RADAR_1KM_RDBS",
    style: "RADARURPREFLECTS14-LINEAR",
    title: "Radar reflectivity (Snow) (1 km) [experimental] [dBZ]",
    interval: -10,
    opacity: 1,
  },
    {
        type: "RDPS",
      layer: "RDPS.ETA_NT",
      style: "CLOUD",
      title: "Total cloud cover [%]",
      interval: 60,
      opacity: 1,
      blend: "screen",
    },
    {
        type: "RDPS",
      layer: "RDPS.CONV_KINDEX.PT3H",
      style: "KINDEX",
      title: "Thunderstorm potential index George K",
      interval: 180,
      opacity: 0.5,
    },
    {
      type: "RDPS",
    layer: "HRDPS.CONTINENTAL.CONV_SHWINX.500",
    style: "LIFTED_INDEX-LINEAR",
    title: "Showalter Index, with reference level 500.0 mb [K]",
    interval: 60,
    opacity: 0.5,
  },
  {
    type: "RDPS",
  layer: "RDPS.CONV_SFC-VT-CAPE",
  style: "CAPE_COARSE-LINEAR",
  title: "CAPE using the virtual temperature correction for parcel lifted from the surface [J/kg]",
  interval: 180,
  opacity: 0.5,
},
    {
        type: "RDPS",
      layer: "RDPS.ETA_TT",
      style: "TEMPERATURE-LINEAR",
      title: "Air temperature [°C]",
      interval: 60,
      opacity: 0.5,
    },
    {
        type: "RDPS",
      layer: "RDPS.ETA_HR",
      style: "HUMIDITYREL-LINEAR",
      title: "Relative humidity [%]",
      interval: 60,
      opacity: 0.5,
    },
    {
        type: "RDPS",
      layer: "RDPS.ETA_UU",
      style: "WINDARROWKMH",
      title: "Winds [m/s]",
      interval: 60,
      opacity: 1,
    },
    {
        type: "RDPS",
      layer: "RDPS.ETA_WSPD",
      style: "WINDSPEEDKMH",
      title: "Wind speed [m/s]",
      interval: 60,
      opacity: 0.5,
    },
    {
        type: "RDPS",
      layer: "RDPS.ETA_WGE",
      style: "GUST_MS2KMH-LINEAR",
      title: "Wind gust estimate [m/s]",
      interval: 60,
      opacity: 1,
    },
  //   {
  //     type: "RDPS",
  //   layer: "CGSL.ETA_ICETK",
  //   style: "SEA_ICETHICK-LINEAR",
  //   title: "Ice thickness [m]",
  //   interval: 60,
  //   opacity: 1,
  //   legend: "https://geo.weather.gc.ca/geomet?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=CGSL.ETA_ICETK&format=image/png&STYLE=SEA_ICETHICK-LINEAR"
  // },
  {
    type: "RDPS",
  layer: "GDPS.ETA_SD",
  style: "SNOWDEPTH-LINEAR",
  title: "Snow depth [m]",
  interval: 60,
  opacity: 1,
},
  {
    type: "RDPS",
  layer: "GDPS.DIAG_NW_PT3H",
  style: "SIGPRECIPITATIONTYPE",
  title: "Significant type of precipitation for 3 hour intervals [mm/3h]",
  interval: 180,
  opacity: 1,
},
{
  type: "RDPS",
layer: "RDPS.DIAG_NW_PT1H",
style: "SIGPRECIPITATIONTYPE",
title: "Significant type of precipitation for 1 hour intervals [mm/1h]",
interval: 60,
opacity: 1,
},
{
  type: "RDPS",
layer: "HRDPS.CONTINENTAL.DIAG_PTYPE",
style: "INSTPRECIPITATIONTYPE",
title: "Instantaneous precipitation type",
interval: 60,
opacity: 1,
},
{
  type: "RDPS",
layer: "HRDPS.CONTINENTAL.PRES_ES.50",
style: "DEWPOINTDEP",
title: "Dew point depression at 50.0 mb [°C]",
interval: 60,
opacity: 0.5,
},
{
  type: "RDPS",
layer: "HRDPS.CONTINENTAL.PRES_ES.150",
style: "DEWPOINTDEP",
title: "Dew point depression at 150.0 mb [°C]",
interval: 60,
opacity: 0.5,
},
  ];